// removed by extract-text-webpack-plugin
module.exports = {"label":"Inputfield__label___3uVg1","inputFieldContainer":"Inputfield__inputFieldContainer___3Uihm","date":"Inputfield__date___1oZZp","time":"Inputfield__time___2_ui5","number":"Inputfield__number___3rkj6","inputField":"Inputfield__inputField___1hHZ2","has-error":"Inputfield__has-error___SUoXo","no-error":"Inputfield__no-error___1vUeR","error":"Inputfield__error___1zxOH","margin-right":"Inputfield__margin-right___2e-fx","grow":"Inputfield__grow___7tcDn","small":"Inputfield__small___1c2wd","flightNumber":"Inputfield__flightNumber___19K7v"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Inputfield/Inputfield.css
// module id = 705
// module chunks = 0